import { render, staticRenderFns } from "./CalendarioPromocionalCalendario.vue?vue&type=template&id=20a4fec4"
import script from "./CalendarioPromocionalCalendario.vue?vue&type=script&lang=js"
export * from "./CalendarioPromocionalCalendario.vue?vue&type=script&lang=js"
import style0 from "./CalendarioPromocionalCalendario.vue?vue&type=style&index=0&id=20a4fec4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports